import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type TransactionItemDetailEditChange = {
  isEdit: boolean;
  onView: () => void;
  onEdit: () => void;
};

const TransactionItemDetailEditContext =
  createContext<TransactionItemDetailEditChange>({
    isEdit: false,
    onView() {},
    onEdit() {},
  });

export const TransactionItemDetailEditProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const handler = useMemo((): TransactionItemDetailEditChange => {
    return {
      isEdit,
      onView: () => {
        setIsEdit(false);
      },
      onEdit: () => {
        setIsEdit(true);
      },
    };
  }, [isEdit]);
  return (
    <TransactionItemDetailEditContext.Provider value={handler}>
      {children}
    </TransactionItemDetailEditContext.Provider>
  );
};

export const useTransactionItemDetailEdit = () =>
  useContext(TransactionItemDetailEditContext);
